import apiClient from './apiClient';

class NewsClient {
    // 按讚新聞
    postNewsThumb = (newsId) => apiClient.post(`/social/news/${newsId}/thumb`);

    // 點擊新聞表情
    postNewsEmoji = (newsId, emojiId) => apiClient.post(`/social/news/${newsId}/emoji/${emojiId}`);

    // 收藏新聞
    collectNews = (newsId) => apiClient.post(`/social/news/${newsId}/favorite`);

    // 新聞留言
    postNewsComment = (newsId, comment) =>
        apiClient.post(`/social/news/${newsId}/comment`, {
            comment,
        });

    // 按讚留言
    postCommentThumb = (newsId, commentId) =>
        apiClient.post(`/social/news/${newsId}/comment/${commentId}/thumb`);

    // 取得新聞留言
    findNewsComment = (newsId) => apiClient.get(`/social/news/comment?newsId=${newsId}`);

    // 取得推薦新聞
    findRelatedNews = (newsId, locale) =>
        apiClient.get(`/news/recommend?newsId=${newsId}`, {
            headers: {
                'X-LANG': 'zh-' + locale,
            },
        });

    // 分享新聞
    shareNews = ({ newsId, media }) =>
        apiClient.post(`/social/share`, {
            newsId,
            media,
        });
}

const newsClient = new NewsClient();

export default newsClient;
